// Angular
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Local library
import { CommonFacade, SessionService } from '@amwager/data-access';
import { isOnline$ } from '@amwager/util-ts';

// Third party
import { forEach } from 'lodash';

/**
 * Shared, UI-agnostic funding helpers.
 * Logic here is moved as-is from the funding components so it can be
 * reused across the deposit/withdraw flows.
 */
@Injectable()
export class FundingService {

  // PayNearMe endpoint config (moved from PayNearMeComponent).
  private readonly PAYNEARME_URL = 'pro.paynearme-sandbox.com';
  private readonly PAYNEARME_SITEID = 'S5373564450';

  constructor(
    private readonly commonFacade: CommonFacade,
    private readonly sessionService: SessionService,
  ) {}

  /** Mark every control in a form group as touched (recurses into nested groups). */
  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  /** Watch connectivity and mirror the online state into the common facade. */
  checkConnectivity(environment: string, source: string, onChange: (online: boolean) => void): void {
    // check internet connection
    isOnline$(environment).subscribe((online: boolean) => {
      onChange(online);
      this.commonFacade.setIsConnectedInternet(source, online);
    });
  }

  /** Open the PayNearMe deposit window for the current user. */
  openPayNearMe(): void {
    const date = new Date(this.sessionService.getUserDOB());

    const payNearMeLink = 'https://' + this.PAYNEARME_URL +
    '/api/buy_now?site_customer_identifier=' + this.sessionService.getSubscription() +
    '&site_identifier=' + this.PAYNEARME_SITEID +
    '&order_currency=USD&order_type=any&site_customer_email=' + this.sessionService.getUserEmail() +
    '&order_is_standing=true' +
    '&site_customer_first_name=' + this.sessionService.getUserFName() +
    '&site_customer_last_name=' + this.sessionService.getUserLast() +
    '&site_customer_year_of_birth=' + date.getFullYear();

    window.open(payNearMeLink,'PayNearMe for Wagering', 'width=800, height=600');
  }

  /** Open the BitPay invoice window for a crypto deposit. */
  openCryptoInvoice(invoiceId: string): void {
    const cryptoCurrency = 'https://bitpay.com/invoice?id='+invoiceId+'&view=modal&v=4';

    window.open(cryptoCurrency,'Crypto Currency for Wagering', 'width=600, height=800');
  }
}
